// extracted by mini-css-extract-plugin
export default {"div":"Error_div__RWpy2","second":"Error_second__jjPGY","image":"Error_image__Ml-vR"};